<template>
  <div id="MobileNav">
    <div class="mobile-bar" :class="{ active: openMenu }">
      <img class="logo" src="@/assets/broncos-nav-logo.png" /></a>
      <div class="btn-menu" @click="() => toggleNav()">
        <div class="hamburger" :class="{ active: openMenu }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mobile-dropdown" :class="{ expand: openMenu }">
      <div class="overlay" />
      <div class="links">
        <template v-for="item in navData">
          <div
            :key="item.title"
            :href="item.anchor"
            v-scroll-to="item.anchor"
            @click="() => toggleNav()"
            class="nav-item"
          >
            {{ item.title }}
          </div>
        </template>
        <!-- <div class="buttons">
          <div class="nav-invoice-btn" v-b-modal.expiringModal><p>Extend Now</p></div>
        </div> -->
        <div class="rep-cnt" v-if="global.userInfo.repEmail != ''">
          <div class="rep-title">Your Account Representative</div>
          <p>
            <span>{{ global.userInfo.repName }}</span>
            <a :href="'mailto:' + global.userInfo.repEmail">{{ global.userInfo.repEmail }}</a>
            <span class="repPhone">{{ global.userInfo.repPhone }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "MobileNav",
    computed: {
      ...mapState(["global"]),
    },
    data() {
      return {
        openMenu: false,
        navData: [
          {
            title: "Home",
            anchor: "#LandingAnchor"
          },
          {
            title: "Extension Offer",
            anchor: "#RenewalOfferAnchor"
          },
          {
            title: "Amenities & Benefits",
            anchor: "#AmenitiesAnchor"
          },
          {
            title: "Seating Map",
            anchor: "#MapAnchor"
          }
        ]
      }
    },
    methods: {
      toggleNav() {
        const newVal = !this.openMenu;
        this.openMenu = newVal;
        document.documentElement.style.overflow = !newVal ? "auto" : "hidden";
      }
    }
  }
</script>

<style lang="scss" scoped>
  #MobileNav {
    z-index: 9;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    .mobile-bar {
      z-index: 999;
      position: absolute;
      top: 40px;
      left: 0;
      width: 254px;
      height: 95px;
      background: url('~@/assets/bg/nav-bg.png') scroll no-repeat center center;
      background-size: 254px 95px;
      @include transition(all 0.5s ease-in-out);
      &.active {
        background: url('~@/assets/bg/nav-bg-active.png') scroll no-repeat center center;
      }
      .logo {
        position: absolute;
        top: 50%;
        left: 20px;
        width: 113px;
        @include transform(translateY(-50%));
      }
      .btn-menu {
        cursor: pointer;
        position: absolute;
        right: 43px;
        top: 50%;
        display: block;
        width: 30px;
        height: 19px;
        @include transform(translateY(-50%));
        .hamburger {
          position: relative;
          width: 100%;
          span {
            position: absolute;
            display: block;
            width: 30px;
            height: 3px;
            left: 0;
            border-radius: 2px;
            background: $white;
            @include transition(all 0.3s linear);
            &:nth-child(1) {
              top: 0;
            }
            &:nth-child(2) {
              top: 8px;
            }
            &:nth-child(3) {
              top: 16px;
            }
          }
          &.active {
            span {
              &:nth-child(1) {
                top: 8px !important;
                transform: rotate(45deg);
              }
              &:nth-child(2) {
                opacity: 0;
              }
              &:nth-child(3) {
                top: 8px !important;
                transform: rotate(-45deg);
              }
            }
          }
        }
      }
    }
    .mobile-dropdown {
      z-index: 0;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding-top: 10%;
      padding-bottom: 10%;
      height: 0;
      opacity: 0;
      width: 100%;
      pointer-events: none;
      @include transition(all 0.5s ease-in-out);
      .overlay {
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.90);
        backdrop-filter: blur(10px);
        height: 100%;
        width: 100%;
      }
      &.expand {
        z-index: 99;
        height: 100vh;
        max-height: 100vh;
        opacity: 1;
        pointer-events: all;
        .links {
          left: 0;
        }
      }
      .links {
        z-index: 2;
        position: absolute;
        display: flex;
        top: 0;
        left: 0;
        flex-direction: column;
        left: -100%;
        top: 0;
        width: 100%;
        max-width: 360px;
        height: 100%;
        background: $blue;
        padding: 200px 25px 0;
        @include transition(all 0.5s ease-in-out);
        .nav-item {
          cursor: pointer;
          margin-bottom: 10px;
          font-size: 20px;
          @include nexaBold;
          text-transform: uppercase;
          color: $white;
          @include transition(all 0.5s ease-in-out);
          &:last-child {
            margin-bottom: 0;
          }
          &:hover {
            color: $orange;
          }
        }
        .popup-cnt {
          .nav-item-popup {
            cursor: pointer;
            margin-bottom: 10px;
            font-size: 20px;
            @include nexaBold;
            text-transform: uppercase;
            color: $white;
            @include transition(all 0.5s ease-in-out);
            &:last-child {
              margin-bottom: 0;
            }
            &:hover {
              color: $orange;
            }
          }
        }
        .buttons {
          margin-top: 10px;
          .nav-invoice-btn {
            cursor: pointer;
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 10px 20px;
            text-decoration: none;
            font-size: 13px;
            @include nexaBold;
            line-height: 18px;
            text-align: center;
            text-transform: uppercase;
            width: 178px;
            height: 33px;
            background: url("~@/assets/bg/white-btn-bg.png") scroll no-repeat center center;
            background-size: 178px 33px;
            color: #FF4B00;
            &.paynow {
              margin-top: 10px;
            }
          }
        }
        .rep-cnt {
          margin-top: 20px;
          .rep-title {
            margin-bottom: 10px;
            font-size: 17px;
            @include nofex;
            line-height: 18px;
            text-align: left;
            text-transform: uppercase;
            color: #f75210;
          }
          p {
            font-size: 12px;
            @include nexaBold;
            line-height: 19px;
            color: $white;
            span {
              display: block;
              font-size: 16px;
              &.repPhone {
                font-size: 12px;
              }
            }
            a {
              margin-bottom: 0;
              display: inline-block;
              font-size: 12px;
              @include nexaBold;
              text-decoration: underline;
              text-transform: none;
              line-height: 19px;
              color: $white;
            }
          }
        }
      }
    }
  }
</style>